import { useCallback } from 'react'
import type { ReactNode } from 'react'
import { closeSecondaryModal, openSecondaryModal } from 'helpers/actions'
import { useAppDispatch } from 'helpers/store'
import { ModalSize } from 'types/enums/ModalSize'

interface OpenSecondaryModalOptions {
    modalSize?: ModalSize
    closeModal?: () => void
    hideCloseButton?: boolean
    [key: string]: unknown
}

export const useOpenSecondaryModal = () => {
    const dispatch = useAppDispatch()

    const closeModal = useCallback(() => {
        dispatch(closeSecondaryModal())
    }, [dispatch])

    const openModal = useCallback(
        (component: ReactNode, options: OpenSecondaryModalOptions = {}, title?: string) => {
            const { closeModal: customCloseModal, ...restOptions } = options

            dispatch(
                openSecondaryModal(
                    component,
                    {
                        ...restOptions,
                        closeModal: customCloseModal || closeModal,
                    },
                    title
                )
            )
        },
        [dispatch, closeModal]
    )

    return {
        openModal,
        closeModal,
    }
}
